export default __webpack_public_path__ + "static/defi-iph-mockup-858fabe3901bc1de16386a18bff197ca.png";